import { AnimatePresence, motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { channelList } from "../../constants/channel-list";
import { useRadioPlayerContext } from "../../providers/RadioPlayerContext";
import { Equlizer, TracksPoweredBy } from "../common";
import { ArrowIcon } from "../icons";

const ChannelList = ({ isOpen, setIsOpen }) => {
  const { currentChannel, switchChannelByIndex } = useRadioPlayerContext();

  const slideUpVariants = {
    hidden: { y: "100%" },
    visible: { y: 0 },
    exit: { y: "100%" },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={slideUpVariants}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="absolute inset-0 bg-[#2b2b32] flex flex-col justify-between z-50"
        >
          <div className="px-4 overflow-auto">
            <ArrowIcon onClick={() => setIsOpen(false)} className="w-12 mx-auto mt-2" />

            <div className="flex items-center justify-between mt-5 mb-7">
              <div className="flex flex-col gap-2">
                <h2 className="text-xl">رادیو آنلاین</h2>
                <p className="text-sm">لیست کانال ها</p>
              </div>

              <TracksPoweredBy />
            </div>

            <div className="flex flex-col gap-3 pb-6">
              {channelList?.map((c, index) => {
                const isActiveChannel = c?.channelTitle === currentChannel.channelTitle;

                return (
                  <div
                    key={c?.channelTitle}
                    onClick={() => {
                      setIsOpen(false);
                      switchChannelByIndex(index);
                    }}
                    className={twMerge(
                      "flex items-center gap-2 bg-[#3b3c46] px-5 py-6 rounded-xl border border-transparent",
                      isActiveChannel && "border-[#fde26b]"
                    )}
                  >
                    {isActiveChannel ? <Equlizer className="size-10" /> : null}
                    <h2
                      className={twMerge(
                        "font-bold text-lg",
                        isActiveChannel && "text-[#fde26b]"
                      )}
                    >
                      {c?.channelTitle}
                    </h2>
                  </div>
                );
              })}
            </div>
          </div>

          <button
            onClick={() => setIsOpen(false)}
            className="p-4 rounded-t-3xl bg-[#494b4d]"
          >
            بازگشت
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ChannelList;
